var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeRel1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.1918C17 17.6105 17.2371 17.053 17.659 16.6419C18.081 16.2309 18.6533 16 19.25 16H26.75C27.3467 16 27.919 16.2309 28.341 16.6419C28.7629 17.053 29 17.6105 29 18.1918V29.9016C29 30.7929 27.965 31.3116 27.221 30.7936L23 27.8567L18.779 30.7936C18.0343 31.3123 17 30.7936 17 29.9023V18.1918Z",
    fill: "#9747FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeRel1);
export default __webpack_public_path__ + "static/media/icone-rel-1.ab1db77b2291498b095219089556cfe0.svg";
export { ForwardRef as ReactComponent };